import { render, staticRenderFns } from "./TrialEmail.vue?vue&type=template&id=640f8891&scoped=true"
import script from "./TrialEmail.vue?vue&type=script&lang=js"
export * from "./TrialEmail.vue?vue&type=script&lang=js"
import style0 from "./TrialEmail.vue?vue&type=style&index=0&id=640f8891&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640f8891",
  null
  
)

export default component.exports